"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuantityPicker = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _internal = require("../../hooks/internal");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const QuantityPicker = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    code,
    quantityPicker,
    onQuickBuyButtonClick
  } = (0, _internal.useProduct)();
  const isMobile = (0, _presentationHooks.useIsMobile)();
  // istanbul ignore next @preserve --no need to test mobile size
  const size = isMobile ? 'medium' : 'large';
  const onChange = (0, _react.useCallback)((newValue, id, source) => {
    onQuickBuyButtonClick?.({
      newValue,
      id,
      source
    });
  }, [onQuickBuyButtonClick]);
  const {
    visible,
    onClick,
    ...restQuantityPicker
  } = quantityPicker ?? {};
  const onQuantityPickerClick = (0, _react.useCallback)(event => {
    event.preventDefault();
    event.stopPropagation();
    onClick?.(event);
  }, [onClick]);
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Fade, {
    in: true,
    timeout: 500,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.QuantityPicker, {
      "data-testid": getTestId(_constants.QUANTITY_PICKER),
      id: code,
      size: size,
      onChange: onChange,
      onClick: onQuantityPickerClick,
      ...restQuantityPicker
    })
  });
};
exports.QuantityPicker = QuantityPicker;
//# sourceMappingURL=QuantityPicker.js.map